import React from "react";
import { HubSpotEmbedForm } from "~/molecules/HubSpotEmbedForm";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";

type Props = {
  hubspotFormId?: string | null;
  formTargetId?: string;
};

export const DownloadApplicationForm: React.FC<Props> = ({
  hubspotFormId,
  formTargetId = "download-application-form",
}) => {
  return (
    <>
      <style jsx>{`
        .formCard {
          background: ${colors.white};
          border: 1px solid ${colors.gray3};
          border-radius: 16px;
          box-sizing: border-box;
          padding: 24px 20px 20px;
          scroll-margin-top: 140px;
          width: 100%;
        }
        @media (${breakPoints.sp}) {
          .formCard {
            border-radius: 12px;
            padding: 20px 16px 16px;
            scroll-margin-top: 140px;
          }
        }
      `}</style>
      <div id={formTargetId} className="formCard" data-hubspot-form-scroll-anchor>
        <HubSpotEmbedForm hubspotFormId={hubspotFormId} />
      </div>
    </>
  );
};
